module.exports = __webpack_public_path__ + "img/ek.c7ca71cc.png";